import { makeEntityScaffold } from '@classpass/saga-tools';

export const achievementsPastReservations = makeEntityScaffold('SAGA.API.ACHIEVEMENTS_PAST_RESERVATIONS', client =>
  client.achievements.pastReservations().then(data => data)
);

export const achievementsPastReservationsCount = makeEntityScaffold(
  'SAGA.API.ACHIEVEMENTS_PAST_RESERVATIONS_COUNT',
  client => client.achievements.pastReservationsMeta().then(data => data)
);
